// 导入api接口模块
import home from './home'
// 导入购物车商品接口
import trolley from './shopping-troelly'

// 获取当前环境变量 true => 生产环境 false => 开发环境 const BASEURL = (process.env.NODE_ENV === 'production') ? '/api' : '/api'
 const BASEURLDUO = 'https://www.dadiandi.top/api'// 正式服，打包发布需要调整过来
// const BASEURLDUO = 'http://localhost:8014/api' // 本地

 const BASEURL = 'https://www.dadiandi.top/api'   // 正式服，打包发布需要调整过来
// const BASEURL = 'http://localhost:8014/api' // 本地
export const api = {
  // 登录模块
  ...home(BASEURL),
  ...trolley(BASEURL, BASEURLDUO),
  // vCode: `${BASEURL}/app/getCode`,
  vCode: `${BASEURLDUO}/user/getCode`,
  // login: `${BASEURL}/app/login`,
  login: `${BASEURLDUO}/login`,
  loginByPhone: `${BASEURLDUO}/loginByPhone`,
  register: `${BASEURLDUO}/register`,
  updatePass: `${BASEURLDUO}/updatePass`, // 修改密码
  updateForgotPass: `${BASEURLDUO}/updateForgotPass`, // 忘记密码修改
  qqAuth: `${BASEURLDUO}/auth/qqAuth`, // qq授权绑定登录地址
  wxAuth: `${BASEURLDUO}/auth/wx/login`, // 微信二维码扫描
  // 登录协议列表
  getLoginAgreements: `${BASEURLDUO}/loginAgreement/getLoginAgreements`,
  // 登录协议内容
  getLoginAgreementList: `${BASEURLDUO}/loginAgreement`,
  // 修改订单地址
  updateOrderAddress: `${BASEURLDUO}/order/updateOrderAddress`,
  // 猜你喜欢
  guessYourLike: `${BASEURLDUO}/product/hot`,

  // 获取物流信息
  getExpressInfo: `${BASEURLDUO}/orderExpress/details`,
  // 底部信息
  getNewCopyRight: `${BASEURLDUO}/copyright/getNewCopyRight`,
  // 关于我们
  records: `${BASEURLDUO}/siteConfig/Records`,
  // 图片上传
  upload: `${BASEURLDUO}/file/uploadFile`,
  // 店铺模块
  getShopClassify: `${BASEURL}/shop/getShopClassify`, // 查询店铺分类
  getShopProducts: `${BASEURL}/shop/getShopProducts`, // 查询店铺商品
  getShopBanner: `${BASEURL}/shop/getShopBanner`, // 获取店铺banner
  // 我的评价模块
  // getEvaluateList: `${BASEURL}/comment/getAll`, // 查询我的评价列表
  getEvaluateList: `${BASEURLDUO}/user/replys`, // 查询我的评价列表
  likes: `${BASEURL}/comment/like`, // 点赞
  getEvaluateData: `${BASEURL}/comment/getById`, // 查询评价内容
  // 首页模块
  // getSearchProducts: `${BASEURL}/app/getSearchProducts`, // 搜索商品
  getSearchProducts: `${BASEURLDUO}/products`, // 搜索商品
  getShops: `${BASEURL}/shop/getShops`, // 搜索店铺
  // 分类模块
  // getClaasifyProducts: `${BASEURL}/classify/getClaasifyProducts`, // 查询分类商品
  getClaasifyProducts: `${BASEURLDUO}/products`, // 查询分类商品
  // 订单模块
  // getOrderList: `${BASEURL}/order/getAll`, // 查询订单列表
  getOrderList: `${BASEURLDUO}/order/list`, // 查询订单列表
  getOrderListPage: `${BASEURLDUO}/order/listByPc`, // 查询订单列表

  refundOrder: `${BASEURLDUO}/order/refund/reason`, // 申请退款

  postOrderComputed: `${BASEURLDUO}/order/computed`, // 查询订单详情

  // getOrderDetail: `${BASEURL}/order/getById`, // 查询订单详情
  getOrderDetail: `${BASEURLDUO}/order/detail`, // 查询订单详情

  // cancelOrder: `${BASEURLDUO}/order/cancel`, // 取消订单
  cancelOrder: `${BASEURLDUO}/order/cancelOrder`, // 取消订单

  confirm: `${BASEURLDUO}/order/confirm`, // 确认
  take: `${BASEURLDUO}/order/take`, // 确认收获

  deleteOrder: `${BASEURL}/order/delete`, // 删除订单
  getExpressSelect: `${BASEURL}/order/getExpressSelect`, // 选择物流公司查询
  getYxExpressList: `${BASEURLDUO}/orderExpress/getYxExpressList`, // 退货退款选择物流公司
  returnExpress: `${BASEURL}/order/returnExpress`, // 填写退货物流单
  addComment: `${BASEURL}/order/addComment`, // 添加评论
  comment: `${BASEURLDUO}/order/comment`, // 添加评论

  addToComment: `${BASEURL}/order/addToComment`, // 追加评论
  getDilevery: `${BASEURL}/order/getDilevery`, // 查询物流信息
  buyAgain: `${BASEURL}/cart/buyAgain`, // 再次购买
  // 收货地址模块
  addressList: `${BASEURLDUO}/address/list`, // 收货地址管理查询
  selectAddress: `${BASEURLDUO}/address/detail`, // 选择收货地址查询
  changeAddress: `${BASEURLDUO}/address/getById`, // 修改收货地址查询
  delAddress: `${BASEURLDUO}/address/del`, // 删除收货地址
  updateAddress: `${BASEURLDUO}/address/edit`, // 修改收货地址
  newAddress: `${BASEURLDUO}/address/edit`, // 添加收货地址
  setDefault: `${BASEURLDUO}/address/default/set`, // 添加收货地址
  getTrolleyList: `${BASEURLDUO}/cart/list`,
  // 优惠券模块
  getCoupons: `${BASEURL}/coupon/getCoupons`, // 优惠券列表

  getCouponsList: `${BASEURLDUO}/coupons`, // 优惠券列表
  getCoupontListByCondition: `${BASEURLDUO}/getCoupontListByCondition`, // 优惠券列表不带分页
  // getCouponList: `${BASEURL}/coupon/getCouponList`, // 优惠券列表不带分页

  getCouponList: `${BASEURLDUO}/coupons/user`, // 优惠券列表不带分页
  // takeCoupon: `${BASEURL}/coupon/takeCoupon`, // 领取优惠券
  takeCoupon: `${BASEURLDUO}/coupon/takeCoupon`, // 领取优惠券
  receiveCoupon: `${BASEURLDUO}/coupon/receive`, // 领取优惠券
  getCouponProducts: `${BASEURL}/coupon/getCouponProducts`, // 优惠券商品列表查询
  selectCouponByUId: `${BASEURLDUO}/selectCouponByUId`, // 查询当前用户订单可使用的优惠券
  getUnreceivedCouponList: `${BASEURLDUO}/getUnreceivedCouponList`,
  getProductByCoupon: `${BASEURLDUO}/getProductByCoupon`,
  // 个人信息模块
  getUser: `${BASEURLDUO}/userinfo`, // 个人系信息查询
  updatePassword: `${BASEURL}/user/updatePassword`, // 修改密码
  relievePhone: `${BASEURL}/user/relievePhone`, // 解除绑定手机号
  updatePhone: `${BASEURLDUO}/user/updatePhone`, // 更换绑定手机号
  update: `${BASEURLDUO}/user/edit`, // 修改个人信息
  // checkUser: `${BASEURL}/user/checkUser`, // 身份验证
  checkUser: `${BASEURLDUO}/user/checkUser`, // 身份验证

  // 商品模块
  // getProDetail: `${BASEURL}/product/getById`, // 商品详情
  getProDetail: `${BASEURLDUO}/product/detail`, // 商品详情
  getProOption: `${BASEURL}/product/getProducts`, // 选择商品配置信息
  // addCart: `${BASEURL}/cart/addCart`, // 加入购物车
  addCart: `${BASEURLDUO}/cart/add`, // 加入购物车
  getEvaluate: `${BASEURL}/comment/getProductAll`, // 商品评价
  // 结算模块
  getSettlement: `${BASEURL}/order/getSettlement`, // 加入购物车
  // 画布模块
  fileUpload: BASEURL + '/file/upload', // 文件上传
  getClassify: BASEURLDUO + '/index', // 查询分类层级 /canvas/getClassify

  // getProducts: BASEURL + '/canvas/getProducts', // 选择商品查询
  getProducts: BASEURLDUO + '/api/product/detail', // 选择商品查询
  collectAdd: BASEURLDUO + '/collect/add', // 收藏商品
  collectDel: BASEURLDUO + '/collect/del', // 取消收藏
  userCollectProduct: BASEURLDUO + '/collect/userCollectProduct', // 我的收藏列表

  getCanvas: BASEURL + 'canvas/getCanvas', // 读取画布canvas/getCanvas
  getCanvasMenu: BASEURLDUO + '/category', // 读取左侧菜单
  getProductsFirst: BASEURLDUO + '/products', // 读取商品列表
  // 支付模块
  getOrderCoupons: `${BASEURL}/order/getOrderCoupons`, // 结算列表优惠券
  // orderSubmit: `${BASEURL}/order/submit`, // 结算列表优惠券

  orderSubmit: `${BASEURLDUO}/order/create`, // 订单结算
  pay: `${BASEURL}/order/pay`, // 支付
  getPayCode: `${BASEURL}/order/getUrl`, // 根据订单id获取收款码
  checkPay: `${BASEURL}/order/checkPay`, // 监听支付
  // 售后
  // submit: `${BASEURL}/after/submit`, // 申请售后

  submit: `${BASEURLDUO}/order/refund/verify`, // 申请售后

  getReasonSelect: `${BASEURL}/after/getReasonSelect`, // 选择退款原因查询
  returnRefund: `${BASEURL}/after/returnRefund`, // 撤销退款
  returnGoods: `${BASEURL}/after/returnGoods`, // 撤销退货
  getPay: BASEURL + '/order/pay', // 支付处理业务
  getAfterSaleList: `${BASEURL}/after/getAll`, // 获取售后列表
  getAfterSaleDetail: `${BASEURL}/after/getById`, // 获取售后订单详情
  platform: `${BASEURL}/after/platform`, // 申请平台介入
  getCartCount: `${BASEURLDUO}/cart/count`, // 购物车数量
  getReplyList: `${BASEURLDUO}/reply/list`, // 商品详情评论
  getReplyCount: `${BASEURLDUO}/reply/count`, // 根据类型查询商品总数
  // 首页楼层
  getlistByFirst: `${BASEURLDUO}/groom/listByFirst`, // 根据类型查询商品总数

  getlistByFirstType: `${BASEURLDUO}/groom/list`, // 根据类型查询商品总数
  getProductsByType: `${BASEURLDUO}/groom/getProductsByType`, // 根据类型查询商品分页
  // 商城:数据配置管理
  selectBannerList: `${BASEURLDUO}/seckill/selectBannerList`, // 查询轮播图

  // 新增发票信息
  saveInvoiceInfo: `${BASEURLDUO}/invoice/info/add`,
  // 查询发票信息
  invoiceInfoRecords: `${BASEURLDUO}/invoice/info/records`,

  // 删除发票信息
  delInvoiceInfo: `${BASEURLDUO}/invoice/info/delete`,

  updInvoiceInfo: `${BASEURLDUO}/invoice/info/update`,
  // 发票
  invoiceAdd: `${BASEURLDUO}/invoice/add`, // 新增订单发票
  invoiceDefaultInfo: `${BASEURLDUO}/invoice/info/unit/defalut`, // 用户默认发票
  queryFoot: `${BASEURLDUO}/foot/list`,

  queryServe: `${BASEURLDUO}/serve/records`,

  messageRecords: `${BASEURLDUO}/message/records`,
  messageTotal: `${BASEURLDUO}/message/total`,
  messageRead: `${BASEURLDUO}/message/read`
}
export default api



// WEBPACK FOOTER //
// ./src/api/index.js